import { FixedHeaderSection } from '@sportybot-web/components/layout/fixed-header-section/fixed-header-section';
import { GameViewHeader } from '@sportybot-web/features/game-view/components/game-view-header';
import { gameViewSearchSchema } from '@sportybot-web/features/game-view/schemas/game-view-params';
import { DEFAULT_SPORT_ID } from '@sportybot-web/services/stats-api/constants';
import { formatScheduleDate } from '@sportybot-web/utils/date';
import { createFileRoute, Outlet, stripSearchParams } from '@tanstack/react-router';

/* eslint-disable perfectionist/sort-objects */
export const Route = createFileRoute('/_authenticated/game-view')({
  component: RouteComponent,
  validateSearch: gameViewSearchSchema,
  search: {
    middlewares: [
      stripSearchParams({
        get date() {
          return formatScheduleDate();
        },
        get sportId() {
          return DEFAULT_SPORT_ID;
        },
      }),
    ],
  },
});
/* eslint-enable perfectionist/sort-objects */

function RouteComponent() {
  return (
    <FixedHeaderSection>
      <GameViewHeader />
      <Outlet />
    </FixedHeaderSection>
  );
}
